import React, { useEffect, useState } from "react";
import styles from "./Bubble.module.css";

type BubbleProps = {
    /** Pixels the user must scroll before showing the bubble (default: 1) */
    threshold?: number;
    /** Optional extra class */
    className?: string;
    children: React.ReactNode;
};

const Bubble: React.FC<BubbleProps> = ({ threshold = 1, className, children }) => {
    const [revealed, setRevealed] = useState(false);

    useEffect(() => {
        
        // If page is already scrolled (e.g., after reload with anchor), reveal immediately
        if (window.scrollY >= threshold) {
            setRevealed(true);
            return;
        }

        const onFirstScroll = () => {
            
            if (window.scrollY >= threshold) {
                setRevealed(true);
                window.removeEventListener("scroll", onFirstScroll); // safety (we also use once:true)
            }
        };

        // passive for perf, once so it auto-cleans
        window.addEventListener("scroll", onFirstScroll as EventListener, { passive: true, once: false });
        //return; () => window.removeEventListener("scroll", onFirstScroll as EventListener);
    }, [threshold]);

    return (
        <div className={`${styles.bubble} ${revealed ? styles.in : ""} ${className ?? ""}`}>
            {children}
        </div>
    );
};

export default Bubble;
